export function scrollState(state = {}, action) {
  switch (action.type) {
    case 'SCROLL_STATE':
      return action.scroll_state;
    default:
      return state;
  }
}

export function scrollDirectionState(state = 'top', action) {
  switch (action.type) {
    case 'SCROLL_DIRECTION':
      return action.direction;
    default:
      return state;
  }
}

export function resizeState(state = {}, action) {
  switch (action.type) {
    case 'RESIZE_STATE':
      return action.resize_state;
    default:
      return state;
  }
}

export function heroState(state = false, action) {
  switch (action.type) {
    case 'HOME_HERO':
      return action.bool;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/r_window_data.js